import PropTypes from 'prop-types'
import { styled } from '@mui/system'
import {
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Icon,
  SvgIconTypeMap,
  Tooltip
} from '@mui/material'
import { useLocation, useNavigate } from 'react-router-dom'
import { resetPagination } from 'store/actions/PaginationAction'
import { resetFiltreCopies } from 'store/actions/FiltreCopiesAction'
import { resetFiltreOrgans } from 'store/actions/FiltreOrgansAction'
import { resetFiltrePlantilles } from 'store/actions/FiltrePlantillesAction'
import { useAppDispatch } from 'hooks'
import ManageSearchIcon from '@mui/icons-material/ManageSearch'
import GroupsIcon from '@mui/icons-material/Groups'
import HistoryIcon from '@mui/icons-material/History'
import { RouteNames } from 'models/routes'
import { OverridableComponent } from '@mui/material/OverridableComponent'
import { IconType } from 'react-icons'

interface SidebarItemsProps {
  isAdmin: boolean
  sidebarOpen: boolean
}

const SidebarListItem = styled(ListItem)(({ theme }) => ({
  margin: 0,
  marginRight: '1rem'
}))

const StyledIcon = styled(Icon)<{
  component:
    | (OverridableComponent<SvgIconTypeMap<object, 'svg'>> & {
        muiName: string
      })
    | IconType
}>({
  fontSize: 'x-large'
})

const SidebarItems = ({ isAdmin, sidebarOpen }: SidebarItemsProps) => {
  const navigate = useNavigate()
  const location = useLocation()

  const dispatch = useAppDispatch()

  const handleNavigation = (path: RouteNames) => {
    dispatch(resetPagination())
    dispatch(resetFiltreCopies())
    dispatch(resetFiltreOrgans())
    dispatch(resetFiltrePlantilles())
    navigate(path)
  }

  const items = [
    {
      route: RouteNames.home,
      label: "Consulta l'històric",
      icon: HistoryIcon,
      display: true
    },
    {
      route: RouteNames.llistatPlantilles,
      label: 'Consulta les plantilles',
      icon: ManageSearchIcon,
      display: isAdmin
    },
    {
      route: RouteNames.llistatOrgans,
      label: 'Consulta els òrgans',
      icon: GroupsIcon,
      display: isAdmin
    }
  ]

  return (
    <>
      <List sx={{ width: '100%' }}>
        {items.map(
          (item, index) =>
            item.display && (
              <Tooltip
                enterDelay={1000}
                enterNextDelay={1000}
                title={sidebarOpen ? '' : item.label}
                key={index}
                placement="right">
                <SidebarListItem disablePadding>
                  <ListItemButton
                    onClick={() => handleNavigation(item.route)}
                    sx={{ justifyContent: 'center', minHeight: 56 }}
                    selected={location.pathname === item.route}>
                    <ListItemIcon sx={{ minWidth: 0 }}>
                      <StyledIcon component={item.icon} />
                    </ListItemIcon>
                    {sidebarOpen && (
                      <ListItemText
                        primaryTypographyProps={{
                          paddingLeft: '.75rem',
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis'
                        }}>
                        {item.label}
                      </ListItemText>
                    )}
                  </ListItemButton>
                </SidebarListItem>
              </Tooltip>
            )
        )}
      </List>
    </>
  )
}

SidebarItems.propTypes = {
  isAdmin: PropTypes.bool.isRequired
}

export default SidebarItems
